<template>
  <div class="file-list-body">
    <div style="height: 20px; background: #fff"></div>
    <el-row>
      <el-col :lg="8" :xl="6" v-for="(item, index) in info" :key="index">
        <!--图片预览 -->
        <div class="demo-image__preview">
          <el-image
            :class="
              item.isBase64
                ? 'file_list_body_image_base64'
                : 'file_list_body_image'
            "
            :src="item.aptitudeUrl"
            fit="contain"
            @click="clickHandler(item)"
          >
          </el-image>
        </div>
        <div class="file-list-body-desc">
          <div>
            <div v-if="item.fileType === 10">
              <p :class="stylenetworkAddress" :title="item.aptitudeName">
                {{ item.fileClassName + "：" + item.aptitudeName }}
              </p>

              <div
                v-if="item.networkAddress || item.certificateAuthority === ''"
              >
                <p
                  :class="stylenetworkAddress"
                  :title="item.networkAddress || item.certificateAuthority"
                >
                  发证机关：{{
                    item.networkAddress || item.certificateAuthority
                  }}
                </p>
              </div>
              <div v-else>
                <p>
                  发证机关：{{
                    item.networkAddress || item.certificateAuthority
                  }}
                </p>
              </div>
            </div>
            <div v-else>
              <p :title="item.aptitudeName" :class="stylenetworkAddress">
                {{ item.aptitudeName }}
              </p>
            </div>
          </div>

          <p v-show="isShowEffectTime(item)">
            有效期：
            <span>
              {{ item.effectBeginTime }}至{{ item.effectEndTime || "长期" }}
            </span>
          </p>
        </div>
      </el-col>
    </el-row>
    <div class="demo-image__preview">
      <el-image
        style="width: 0px; height: 0px"
        :src="dialogImageUrl"
        @closeViewer="closeViewer"
        :showViewer="showViewer"
        :preview-src-list="dialogImageUrlArr"
      >
      </el-image>
    </div>
  </div>
</template>

<script>
/**
 *   "商家店铺"中的资质文件预览组件
 */
export default {
  name: "detail-info-file-list",
  props: {
    // 数据
    info: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      showViewer: false,
      dialogPreview: false,
      dialogImageUrl:
        "https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg",
      dialogImageUrlArr: [
        "https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg",
      ],
      isFileDate: [
        "法定代表人身份证",
        "法定代表人授权委托书",
        "银行开户许可证",
        "纳税人证明材料",
        "税务登记证",
      ],
      stylenetworkAddress: ["stylenetworkAddress"],
    };
  },

  methods: {
    clickHandler(item) {
      console.log(item.aptitudeUrl.split(","));
      console.log(111);
      if (item.isBase64) {
        console.log("base64");
        this.$message({
          message: "该文件类型不支持预览",
          type: "warning",
          offset: document.documentElement.clientHeight / 2 - 30,
        });
        return;
      } else {
        console.log(222);
        this.dialogImageUrlArr = [];
        this.dialogImageUrlArr.push(item.aptitudeUrl);
        this.showViewer = true;
      }
    },
    closeViewer() {
      this.showViewer = false;
    },
    dialogImage(data) {},
    downloadFile(uploadId) {
      this.$emit("downloadFile", uploadId);
    },
    isShowEffectTime(data) {
      var isShow = this.isFileDate.find((value, index, arr) => {
        return value === data.aptitudeName;
      });
      if (!data.effectBeginTime && !data.effectEndTime) {
        isShow = true;
      }
      return !isShow;
    },

    disAptiudeName(val) {
      return val.length < 20;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables";
.file-list-body {
  background: #fff;
  padding: 0 100px;
  font-size: 13px;
  color: #4a4a4a;
  font-weight: 500;
  /deep/ .el-col {
    margin-top: 20px;
  }
  .file_list_body_image {
    width: 100px;
    height: 140px;
    cursor: pointer;
    background-color: #f2f2f2;
    /deep/ .el-image__inner {
      @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
        /* IE10以上 */
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
  // 背景图不带颜色 - - 复制了file_list_body_image
  .file_list_body_image_base64 {
    width: 100px;
    height: 140px;
    cursor: pointer;
  }
  /deep/.el-col-lg-8 {
    width: 25%;
  }

  /deep/ .backgroundNone {
    background: none !important;
  }
  .file-list-body-desc {
    height: 100px;
    p:first-child {
      margin-top: 15px;
    }
    p:not(:first-child) {
      margin-top: 10px;
    }
    .file-list-body-desc-file {
      cursor: pointer;
      color: #5576cf;
      i {
        margin-left: 10px;
      }
    }
  }
  .stylenetworkAddress {
    cursor: pointer;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
/deep/ .el-image__preview {
  object-fit: contain;
}
</style>
